import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-welltect-oem-header',
  templateUrl: './welltect-oem-header.component.html',
  styleUrls: ['./welltect-oem-header.component.css'],
})
export class WelltectOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
